<template>
<div class="yo-bg-color-chiaro" style="padding:20px 10px; ">
   <div class="col s12 yo-text-xl yo-text-bold yo-spacing-s black" style="padding:20px 50px;">MODIFICA I TUOI CONSENSI PRIVACY</div>

  <el-form ref="form" :model="privacy" v-on:submit.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;">
  

  <div class="row">
           <div class="col s12">
      Presa visione dell'<a href="https://bvent.biomedia.net/gestionale/privacy_2021001_ita.pdf" target="_blank" style="font-weight:bold;">informativa sulla privacy</a>, consapevole che il mio consenso è puramente facoltativo, oltre che revocabile in qualsiasi momento
      </div>
  </div>

    <div class="row" style="margin-top:32px;">


      <div class="col s12 m10">
      Con riferimento al punto 8 delle Finalità del trattamento contenute nell'informativa
      </div>

      <div class="col s12 m2">
         <el-select v-model="privacy.mkbm"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Acconsento" :value="1" ></el-option>
          <el-option label="Non acconsento" :value="0" ></el-option>
        </el-select>
      </div>
<!--
{{privacy}}
-->



    </div>

    <div class="row" style="margin-top:32px;">

      <div class="col s12 m10" >
       Con riferimento al punto 9 delle Finalità del trattamento contenute nell'informativa
      </div>

      <div class="col s12 m2">
         <el-select v-model="privacy.mktp"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Acconsento" :value="1" ></el-option>
          <el-option label="Non acconsento" :value="0" ></el-option>
        </el-select>
      </div>



<!--
      <el-form-item label="" prop="mkbm" class="no-label">
        <el-select v-model="privacy.mkbm"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Acconsento" :value="1" ></el-option>
          <el-option label="Non acconsento" :value="0" ></el-option>
        </el-select>
      </el-form-item>

      -->



    </div>


   <div class="row pad" style="margin-top:32px;">
      <div class="col s12 m4 offset-m2"><el-button style="width:100%;" @click="onCancel">Indietro</el-button></div>
      <div class="col s12 m4 offset-m2"><el-button type="primary" @click="onSubmit" style="width:100%;">Salva</el-button></div>
    </div>





  



  </el-form>
</div>
</template>

<script>
import dbItem from '../teras/dbItemNew'
export default {
  name: 'contatto-password',
  data () {
      return {
         privacy:{mkbm:1,mktp:0}
      }
   },
  created () {
      this.$teras.page.title = "Mylogin Privacy"
      this.$teras.page.sezione = "myLogin"
      this.privacy.mkbm = (this.$contatto.row.authmkbm.substring(this.$contatto.row.authmkbm.length - 1))*1
      this.privacy.mktp = (this.$contatto.row.authmktp.substring(this.$contatto.row.authmktp.length - 1))*1
   },
  beforeDestroy () {
  },
  methods: {
    onChange(editor, content){
      console.log(".................................................................................:"+editor)
      //this.form.note = editor
    },
    onCancel() {
        this.$router.go(-1)
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          //console.log("CANCELLAZIONE "+this.form.cancellazione)




          this.Save()
        } else {
          return false;
        }
      });
    },
    async Save(){
      let  privacycontatto = new dbItem({table:'privacycontatto'})


      this.$contatto.row.authmkbm=this.$moment().format("YYYY-MM-DD H:mm:")
      this.$contatto.row.authmkbm+=(this.privacy.mkbm==1) ? '01' : '00'
      await privacycontatto.new()
      privacycontatto.row.privacy = 2110001
      privacycontatto.row.contatto = this.$contatto.row.id
      privacycontatto.row.consenso = (this.privacy.mkbm==1) ? 1 : 0
      privacycontatto.row.giorno = this.$moment().format("YYYYY-MM-DD H:mm:ss")
      privacycontatto.save()
      


      
      this.$contatto.row.authmktp=this.$moment().format("YYYY-MM-DD H:mm:")
      this.$contatto.row.authmktp+=(this.privacy.mktp==1) ? '01' : '00'
      await privacycontatto.new()
      privacycontatto.row.privacy = 2110002
      privacycontatto.row.contatto = this.$contatto.row.id
      privacycontatto.row.consenso = (this.privacy.mktp==1) ? 1 : 0
      privacycontatto.row.giorno = this.$moment().format("YYYYY-MM-DD H:mm:ss")
      privacycontatto.save()

      

      await this.$contatto.save()
      this.$router.push('/mylogin-home/')
      
    }

  },
  computed: {
     rules:function() {
      var rulesNow = {
        
      }
      return rulesNow
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Contatto-privacy.vue